var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8934 17.979C12.3617 16.5886 11.3998 14.5816 11.3998 12.35C11.3998 8.15264 14.8024 4.75 18.9998 4.75C23.1972 4.75 26.5998 8.15264 26.5998 12.35C26.5998 14.5816 25.6379 16.5886 24.1062 17.979C29.9891 20.0768 34.1998 25.6967 34.1998 32.3H31.3498C31.3498 25.4793 25.8205 19.95 18.9998 19.95C12.1791 19.95 6.6498 25.4793 6.6498 32.3H3.7998C3.7998 25.6967 8.01054 20.0768 13.8934 17.979ZM18.9998 17.1C21.6232 17.1 23.7498 14.9734 23.7498 12.35C23.7498 9.72665 21.6232 7.6 18.9998 7.6C16.3765 7.6 14.2498 9.72665 14.2498 12.35C14.2498 14.9734 16.3765 17.1 18.9998 17.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.03777003a8b7708c8084a7b1aad52abf.svg";
export { ForwardRef as ReactComponent };